<mapfre-card [singleCard]="false">
<div class="change-address single-card-column" [ngClass]="{'ma-address-change': !isAcmic,'mailing-address':addressType === 'mailing'}"> 
  <div class="row text-center title-container">
    <div class="col"> 
      <div class="header-icon full-icon" *ngIf="addressType !== 'mailing'" >
          <ng-container *ngIf="isAcmic; else maSate">
              <img src="assets/img/images/icon-address-acmic.svg" alt="address icon"/>
          </ng-container>
          <ng-template #maSate>            
              <img src="assets/img/images/icon-location-map-64.svg" alt="location map icon"/>
          </ng-template>
      </div>
      <div class="title">
        <h1 class="title-copy font-weight-normal">{{ typeOfAddress | translate }}</h1> 
      </div>
    </div>
  </div>
  
  <app-change-address-form [inputs]="inputs" [policyStateCode]="policyStateCode" [policyData]="policyData" [policies]="policies"></app-change-address-form>

  </div>
</mapfre-card>